import {ChangeDetectionStrategy, Component} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-data-process-term-helios',
    templateUrl: './data-process-term-helios.component.html',
    styleUrls: ['./data-process-term-helios.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe]
})
export class DataProcessTermHeliosComponent {
}
